import { IconButton, IconButtonProps, Tooltip } from '@wix/design-system';
import classNames from 'classnames';
import React, { FC } from 'react';

import { renderModel } from '../../../util/renderModel';
import s from './styles.scss';

const isBlocks = renderModel.isBlocks();
const isStudioEditor = renderModel.isStudioEditor() || isBlocks;
const isEditor3 = renderModel.isEditor3();


type HeaderActionsIconProps = IconButtonProps & {
  children: React.ReactNode;
  tooltipContent?: string;
};

export const HeaderActionsIcon: FC<HeaderActionsIconProps> = ({
  children,
  tooltipContent,
  className,
  ...iconButtonProps
}) => {
  const isMobile = renderModel.isMobile();

  const getIconSize = () => {
    if (!isEditor3 && !isStudioEditor) {
      return 'small';
    }
    return 'medium';
  };
  const iconButton = (
    <IconButton
      size={getIconSize()}
      skin="transparent"
      {...iconButtonProps}
      className={classNames(
        s.headerActionsIcon,
        {
          [s.studioEditor]: isStudioEditor,
          [s.editor3]: isEditor3,
        },
        className,
      )}
    >
      {children}
    </IconButton>
  );

  const shouldWrapWithTooltip = !isMobile && Boolean(tooltipContent);

  return (
    <>
      {shouldWrapWithTooltip ? (
        <Tooltip
          content={tooltipContent}
          size="small"
          className={classNames({ [s.studioEditorTooltip]: isStudioEditor, [s.editor3Tooltip]: isEditor3, })}
        >
          {iconButton}
        </Tooltip>
      ) : (
        iconButton
      )}
    </>
  );
};
